<template lang="pug">
    v-tooltip(v-if="label" bottom)
        template(v-slot:activator="{ on, attrs }")
            span.carlie-badge.font-weight-bold(
                v-bind="attrs"
                v-on="on"
                :class="xSmall ? 'text-caption' : 'text-body-2'"
            )
                img.mr-1(:src="carlieLogo" :class="xSmall ? 'carlie-badge-logo-x-small' : 'carlie-badge-logo'" alt="Carlie")
                | {{ label }}
        span {{ tooltip }}
</template>

<script lang="ts">
import Vue from 'vue';

// Assets
import carlieLogo from '@/components/carlie/carlie_logo.png';

// Helpers
import { carlieContextDescription, carlieContextLabel } from '@/helpers/carlie';

export default Vue.extend({
    data() {
        return {
            carlieLogo,
        }
    },
    methods: {},
    computed: {
        label(): string {
            return carlieContextLabel(this.context);
        },
        tooltip(): string {
            return carlieContextDescription(this.context);
        },
    },
    components: {},
    props: {
        context: {
            type: String,
            default: null,
        },
        xSmall: {
            type: Boolean,
            default: false,
        },
    },
    watch: {},
    created() {},
    destroyed() {},
    mounted() {},
})
</script>

<style lang="scss" scoped>
    .carlie-badge {
        display: inline-flex;
        align-items: center;
        color: var(--carlie-purple);
        white-space: nowrap;
    }

    .carlie-badge-logo {
        height: 18px;
        width: 18px;
    }

    .carlie-badge-logo-x-small {
        height: 14px;
        width: 14px;
    }
</style>
